import React from 'react';
import { CoverByAuthorizer } from '../../../../models/coverings/coverByAuthorizer';

interface Props {
  handlerSearchCovers: (data: string) => void;
  coversListCopy: CoverByAuthorizer[];
  handlerManagementModal: (status: string, id: number) => void;
}

export const CoverTab = ({
  coversListCopy,
  handlerSearchCovers,
  handlerManagementModal,
}: Props) => {
  console.log(coversListCopy);

  return (
    <>
      <input
        type="text"
        className="form-control w-25"
        placeholder="Buscar..."
        onChange={(e) => handlerSearchCovers(e.target.value)}
      />

      {coversListCopy.map((row, index) => (
        <div key={index} className="border  row my-3">
          <div className="col-12 text-end">
            <i
              className="ri-checkbox-circle-line h3 text-success "
              style={{
                cursor: 'pointer',
              }}
              onClick={() => handlerManagementModal('aprobar', row.id)}
            ></i>
            <i
              className="ri-close-circle-line h3 text-danger "
              style={{
                cursor: 'pointer',
              }}
              onClick={() => handlerManagementModal('rechazar', row.id)}
            ></i>
          </div>
          <div className="row bg-light  m-0 p-0">
            <div className="border col-4 fw-bolder">Empleados</div>

            <div className="border col-4">
              <div className="border-bottom  row justify-content-center">
                Solicitud Cubrimiento: {row?.date?.split('T')[0]}
              </div>

              <div className="text-center  row py-1">
                <div className=" col-6 fw-bolder">Turno asignado</div>
                <div className=" col-6 fw-bolder">Cubrimiento</div>
              </div>
            </div>

            <div className="border col-4">
              <div className="row border-bottom    justify-content-center">
                Pago Cubrimiento: {row?.compensationDate?.split('T')[0]}
              </div>

              <div className="text-center row py-1">
                <div className=" col-6 fw-bolder">Turno asignado</div>
                <div className=" col-6 fw-bolder">Cubrimiento</div>
              </div>
            </div>
          </div>

          <div className="row  m-0 p-0">
            <div className=" border col-4">{row.fullName}</div>

            <div className=" col-4">
              <div className="row text-center">
                <div className="border col-6 ">
                  {row.requesterCurrentInterruptionTypeName ?? row.requesterCurrentWorkshiftName}
                </div>

                <div className="border col-6 ">
                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.interruptionTypeRequestName == null &&
                    row.coverCurrentWorkshiftName}

                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.interruptionTypeRequestName != null &&
                    row.interruptionTypeRequestName}

                  {row.workshiftRequestName !== null &&
                    row.interruptionTypeRequestName == null &&
                    row.workshiftToBeCompensatedName == null &&
                    row.coverCurrentWorkshiftName}

                  {!row.workshiftRequestName &&
                    !row.workshiftToBeCompensatedName &&
                    (row.coverCurrentInterruptionTypeName
                      ? row.coverCurrentInterruptionTypeName
                      : row.interruptionTypeRequestName
                        ? row.interruptionTypeRequestName
                        : row.coverCurrentWorkshiftName)}

                  {row.workshiftToBeCompensatedName &&
                    !row.workshiftRequestName &&
                    (row.coverCurrentInterruptionTypeName
                      ? row.coverCurrentInterruptionTypeName
                      : row.coverCurrentWorkshiftName)}

                  {!row.workshiftToBeCompensatedName &&
                    row.workshiftRequestName &&
                    row.interruptionTypeRequestName}
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="row text-center">
                <div className="border col-6 ">
                  {row.compensationDate && row.requesterCurrentSchedulingOnCompensationDate}
                </div>

                <div className="border col-6 ">
                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.workshiftToBeCompensatedName}

                  {!row.workshiftRequestName &&
                    !row.workshiftToBeCompensatedName &&
                    row.coverCurrentSchedulingOnCompensationDate}

                  {row.workshiftToBeCompensatedName &&
                    row.requesterCurrentInterruptionTypeName &&
                    row.requesterCurrentInterruptionTypeName}

                  {!row.workshiftToBeCompensatedName &&
                    row.workshiftRequestName &&
                    row.coverCurrentSchedulingOnCompensationDate}
                </div>
              </div>
            </div>
          </div>

          <div className="row m-0 p-0">
            <div className="border col-4">{row.fullNameCoverPerson}</div>

            <div className="col-4">
              <div className="row text-center">
                <div className="border col-6 ">
                  {row.coverCurrentInterruptionTypeName ?? row.coverCurrentWorkshiftName}
                </div>

                <div className="border col-6 ">
                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.workshiftRequestName}

                  {!row.workshiftRequestName &&
                    !row.workshiftToBeCompensatedName &&
                    (row.requesterCurrentInterruptionTypeName
                      ? row.requesterCurrentInterruptionTypeName
                      : row.requesterCurrentWorkshiftName)}

                  {row.workshiftToBeCompensatedName &&
                    !row.workshiftRequestName &&
                    (row.requesterCurrentInterruptionTypeName
                      ? row.requesterCurrentInterruptionTypeName
                      : row.requesterCurrentWorkshiftName)}

                  {!row.workshiftToBeCompensatedName &&
                    row.workshiftRequestName &&
                    row.workshiftRequestName}
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="row text-center">
                <div className="border col-6 ">
                  {row.compensationDate && row.coverCurrentSchedulingOnCompensationDate}
                </div>

                <div className="border col-6 ">
                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.interruptionTypeRequestName == null &&
                    row.requesterCurrentSchedulingOnCompensationDate}

                  {row.workshiftRequestName != null &&
                    row.workshiftToBeCompensatedName != null &&
                    row.interruptionTypeRequestName != null &&
                    row.interruptionTypeRequestName}

                  {!row.workshiftRequestName &&
                    !row.workshiftToBeCompensatedName &&
                    row.requesterCurrentSchedulingOnCompensationDate}

                  {row.workshiftToBeCompensatedName &&
                    !row.workshiftRequestName &&
                    row.workshiftToBeCompensatedName}

                  {!row.workshiftToBeCompensatedName &&
                    row.workshiftRequestName &&
                    row.requesterCurrentSchedulingOnCompensationDate}
                </div>
              </div>
            </div>
          </div>

          <div className="row m-0 p-0">
            <div className="col-4 border fw-bolder">Observaciones</div>
            <div className="col-8 border">{row.observations}</div>
          </div>
        </div>
      ))}
    </>
  );
};
